module.exports = __webpack_public_path__ + "static/media/Arrow-up-bright-red.b18310ca.svg";